export const geoOverlayType = {
  addressDetail: 'addressDetail',
};

export const HOME_LABEL = 'HOME_TAG_PRESET';
export const WORK_LABEL = 'WORK_TAG_PRESET';
export const DEFAULT_LABEL_TEXT_I18N = {
  [HOME_LABEL]: 'v2.savedPlace.home',
  [WORK_LABEL]: 'v2.savedPlace.work',
};
export const NONE_EDITING_LABEL = [HOME_LABEL, WORK_LABEL];

export default {};
